import React, { useEffect, useState } from "react";
import Main from "./main";
import ApiDocumentation from "./api-documentation";
import NoDocs from "./no-docs";
import Create from "./content/api/create";
import Detail from "./content/api/detail";
import Update from "./content/api/update";
import DataModelDocs from "./data-model";
import Tokens from "./content/api/tokens";
import PermissionsPage from "./pages/permissions-page";
import SearchPage from "./pages/search-page";
import { DatasetsSchema as DefaultDatasetsSchema } from "./content/models/datasets";
import { ExternalDatasetsSchema as DefaultExternalDatasetsSchema } from "./content/models/external-datasets-schema";
import { fetchSchema } from "../api";
import DarInvenioCliPage from "./pages/dar-invenio-cli-page";
import JsonCreateExamplePage from "./pages/json-create-example-page";

const DocumentationContent = ({ selectedItem }) => {
  const [datasetsSchema, setDatasetsSchema] = useState(DefaultDatasetsSchema);
  const [externalDatasetsSchema, setExternalDatasetsSchema] = useState(
    DefaultExternalDatasetsSchema,
  );

  useEffect(() => {
    const fetchSchemas = async () => {
      try {
        const [fetchedDatasetsSchema, fetchedExternalDatasetsSchema] =
          await Promise.all([
            fetchSchema(
              "https://raw.githubusercontent.com/eLTER-RI/metadata-schemas/refs/heads/main/eLTERMetadataSchemaDatasets_monolith.json",
              DefaultDatasetsSchema,
            ),
            fetchSchema(
              "https://raw.githubusercontent.com/eLTER-RI/metadata-schemas/refs/heads/main/eLTERMetadataSchemaExternalDatasets_monolith.json",
              DefaultExternalDatasetsSchema,
            ),
          ]);

        setDatasetsSchema(fetchedDatasetsSchema);
        setExternalDatasetsSchema(fetchedExternalDatasetsSchema);
      } catch (error) {
        console.error("Error fetching schemas:", error);
      }
    };

    fetchSchemas();
  }, []);

  const contentMapping = {
    main: <Main />,
    user_search: <SearchPage />,
    external_datasets: (
      <DataModelDocs
        modelName="External Datasets"
        schema={externalDatasetsSchema}
      />
    ),
    datasets: <DataModelDocs modelName="Datasets" schema={datasetsSchema} />,
    api_usage: (
      <ApiDocumentation>
        <Tokens />
      </ApiDocumentation>
    ),
    creation: (
      <ApiDocumentation>
        <Create />
      </ApiDocumentation>
    ),
    record_detail: (
      <ApiDocumentation>
        <Detail />
      </ApiDocumentation>
    ),
    record_update: (
      <ApiDocumentation>
        <Update />
      </ApiDocumentation>
    ),
    record_delete: <ApiDocumentation />,
    files: <ApiDocumentation />,
    publication: <ApiDocumentation />,
    quality_checks: <ApiDocumentation />,
    search: <ApiDocumentation />,
    json_create_example: <JsonCreateExamplePage />,
    permission_table: <PermissionsPage />,
    dar_invenio_cli: <DarInvenioCliPage />,
    default: <NoDocs />,
  };

  return contentMapping[selectedItem] ?? contentMapping.default;
};

export default DocumentationContent;
